import { Component } from '@angular/core';

import { WindowService } from '../../../../../common/angular-shared/services/window/window.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LogoutComponent } from '../../../../../coverpath-common/angular/components/logout/logout.component';
import { Controller } from '../../Controller';
import { AuthenticationService } from '../../../../../coverpath-common/angular/services/authentication/authentication.service';

@Component({
  moduleId: module.id,
  selector: 'logout',
  templateUrl: './coverpath-logout.component.html',
})
export class CoverpathLogoutComponent extends LogoutComponent {
  protected getController(): Controller {
    return this.windowService.nativeWindow.controller;
  }

  constructor(
    protected authenticationService: AuthenticationService,
    protected windowService: WindowService,
    protected router: Router,
    protected route: ActivatedRoute
  ) {
    super(authenticationService, windowService, router, route);
  }
}
